// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g_y0","content":"styles_content__2LrAx","row":"styles_row__1WhEK","footer":"styles_footer__2A3_S","phraseLength":"styles_phraseLength__2I3K5"};